import * as React from "react";
import type { SVGProps } from "react";
const SvgMessageAlertPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 14.4V12m0 0V9.6m0 2.4H9.6m2.4 0h2.4m7.2 0c0 1.38-.292 2.692-.816 3.878l.817 5.721-4.903-1.226a9.56 9.56 0 0 1-4.699 1.227 9.6 9.6 0 1 1 9.6-9.6"
    />
  </svg>
);
export default SvgMessageAlertPlus;
